import { schema } from 'normalizr';

const learningLessonSchema = new schema.Entity('learningLessons', {});

export default learningLessonSchema;
